import React from 'react';

import { IPohodnikRouterItem } from '.';

const EquipPage = React.lazy(() => import('@apps/Equip/pages/EquipPage'));
const EquipPageOne = React.lazy(() => import('@apps/Equip/pages/EquipPageOne'));
const EquipPageBackpacks = React.lazy(() => import('@apps/Equip/pages/EquipPageBackpacks'));
const EquipPageSets = React.lazy(() => import('@apps/Equip/pages/EquipPageSets'));
const EquipPageBackpackOne = React.lazy(() => import('@apps/Equip/pages/EquipPageBackpackOne'));
const EquipPageSetOne = React.lazy(() => import('@apps/Equip/pages/EquipPageSetOne'));

const equipRoutes: Array<IPohodnikRouterItem> = [
  {
    path: '/equip/:id',
    component: ({
      match: {
        params: { id },
      },
    }) => <EquipPageOne id_equip={id} />,
    protected: true,
    title: 'Страница элемента снаряжения',
  },
  {
    path: '/equip/backpacks',
    component: () => <EquipPageBackpacks />,
    protected: true,
    title: 'Список рюкзаков',
  },

  {
    path: '/equip/backpacks/:id',
    component: ({
      match: {
        params: { id },
      },
    }) => <EquipPageBackpackOne id_backpack={id} />,
    protected: true,
    title: 'Рюкзак',
  },
  {
    path: '/equip/sets',
    component: () => <EquipPageSets />,
    protected: true,
    title: 'Сборки рюкзаков',
  },
  {
    path: '/equip/sets/:id',
    component: ({
      match: {
        params: { id },
      },
    }) => <EquipPageSetOne id_set={id} />,
    protected: true,
    title: 'Сборка рюкзака',
  },
  {
    path: '/equip',
    component: () => <EquipPage />,
    protected: true,
    title: 'Снаряжение',
  },
];

export default equipRoutes;
